import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/appusers";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import AppFrame from "./Appframe/AppFrame";
import Title from "../components/common/Title";
import IconDelete from "material-ui/svg-icons/action/delete";
import IconEdit from "@material-ui/icons/Edit";

import CustomRewards from "../services/customRewards";

import { Select, MenuItem, FormControl, IconButton } from "@material-ui/core/";

import layout from "../styles/layout";
import config from "../config";
import "../resources/styles/ManageCustomAwards.css";

class ManageCustomRewards extends Component {
  constructor(props) {
    super(props);

    let appId = props.match.params.appId;

    this.state = {
      appId,
      appInfo: this.props.apps.appInfos[appId],
      selectedAwardName: null,
      customAwardsList: [],
      customAwardText: "",
      awardsArray: [
        "Committed To Success",
        "Daily Reporter",
        "Weekend Warrior",
        "Multi-Month",
        "Therapy Star",
        "1K Club",
        "+1000 pts",
        "+2000 pts",
        "+3000 pts",
        "+4000 pts",
        "+5000 pts",
        "+10000 pts",
        "+25000 pts",
        "+50000 pts",
        "+100000 pts",
        "+150000 pts",
        "+200000 pts",
        "+250000 pts",
      ],
    };

    this.save = this.save.bind(this);
    this.update = this.update.bind(this);
    this.saveOrUpdate = this.saveOrUpdate.bind(this);

    this.cancel = this.cancel.bind(this);
    this.edit = this.edit.bind(this);
    this.delete = this.delete.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
  }

  componentDidMount() {
    CustomRewards()
      .getCustomRewardsList(
        this.props.match.params.appId,
        this.props.user.userId
      )
      .then((resp) => {
        this.setState({ customAwardsList: resp.rewardsList });
      });
  }

  componentWillUnmount() {}

  handleSelectChange = (event) => {
    this.setState({ selectedAwardName: event.target.value });
  };
  handleTextChange = (event) => {
    this.setState({ customAwardText: event.target.value });
  };

  cancel() {
    this.setState({
      customAwardText: "",
      selectedAwardName: "",
    });
  }

  saveOrUpdate() {
    if (this.state.isEdit) {
      this.update();
    } else {
      this.save();
    }
  }

  update() {
    CustomRewards()
      .updateCustomReward(
        this.state.editId,
        parseInt(this.props.match.params.appId, 10),
        this.state.selectedAwardName,
        this.state.customAwardText
      )
      .then((resp) => {
        let updatedAwards = this.state.customAwardsList.map((award) => {
          if (award.awardId === this.state.editId) {
            return {
              id: this.state.editId,
              name: this.state.selectedAwardName,
              description: this.state.customAwardText,
            };
          } else {
            return award;
          }
        });

        this.setState({
          customAwardsList: updatedAwards,
          customAwardText: "",
          selectedAwardName: "",
          isEdit: false,
          editId: null,
        });
      })
      .catch((ex) => {});
  }

  save() {
    CustomRewards()
      .addCustomReward(
        this.props.match.params.appId,
        this.state.selectedAwardName,
        this.state.customAwardText
      )
      .then((resp) => {
        let updatedAwards = this.state.customAwardsList;
        updatedAwards.push({
          id: resp.id,
          name: this.state.selectedAwardName,
          description: this.state.customAwardText,
        });
        this.setState({
          customAwardsList: updatedAwards,
          customAwardText: "",
          selectedAwardName: "",
          isEdit: false,
          editId: null,
        });
      });
  }

  edit(id, name, description) {
    this.setState({
      isEdit: true,
      editId: id,
      customAwardText: description,
      selectedAwardName: name,
      editName: name,
    });
  }

  delete(id) {
    CustomRewards()
      .deleteCustomReward(id, this.props.match.params.appId)
      .then((resp) => {
        let updatedAwards = this.state.customAwardsList.filter(
          (award) => award.awardId !== id
        );

        this.setState({
          customAwardsList: updatedAwards,
          customAwardText: "",
          selectedAwardName: "",
          isEdit: false,
          editId: null,
        });
      })
      .catch((ex) => {});
  }

  goToChannelDetails() {
    let link = `/view-app-detail/${this.state.appId}`;
    this.props.history.push(link);
  }

  render() {
    let targetDevice = "desktop";

    if (this.state.width < config.system.mobileScreenWidthThreshold) {
      targetDevice = "mobile";
    }
    return (
      <AppFrame
        auth={this.props.auth}
        title="Manage Custom Rewards"
        targetDevice={targetDevice}
      >
        <Title
          text2="Custom Rewards"
          goBack={() => this.goToChannelDetails()}
        />
        <div style={{ ...layout.common.page, margin: 20 }}>
          <p>
            Custom rewards show in the awards section of the application. This
            area will allow you to configure custom rewards your patients will
            receive when milestones are reached completing their custom
            programs.
          </p>

          <div
            style={{
              ...layout.common.paperContainer,
              width: "60%",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <h2>
              {this.state.isEdit ? "Update Custom Reward" : "Add Custom Reward"}
            </h2>
            <FormControl fullWidth>
              <span>Award Milestone</span>
              <Select
                id="select-award"
                variant="standard"
                value={this.state.selectedAwardName}
                onChange={this.handleSelectChange}
              >
                {this.state.awardsArray
                  .filter((award) => {
                    let keep = true;
                    this.state.customAwardsList.map((custAward) => {
                      if (
                        custAward.name === award &&
                        award !== this.state.editName
                      ) {
                        keep = false;
                      }
                      return null;
                    });
                    return keep;
                  })
                  .map((award) => (
                    <MenuItem value={award}>{award}</MenuItem>
                  ))}
              </Select>
            </FormControl>
            <br />
            <br />
            <TextField
              id="standard-multiline-flexible"
              label="Custom Award Description"
              multiline
              rows={4}
              maxRows={4}
              fullWidth
              value={this.state.customAwardText}
              onChange={this.handleTextChange}
              variant="standard"
            />
            <br />
            <br />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="outlined"
                color="secondary"
                onClick={this.cancel}
                style={{ marginRight: 10 }}
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={this.saveOrUpdate}
                style={{ marginRight: 10 }}
              >
                {this.state.isEdit
                  ? "Update Custom Reward"
                  : "Save Custom Reward"}
              </Button>
            </div>
          </div>

          <h2>Custom Rewards List</h2>
          <table className="awards_table">
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
            {this.state.customAwardsList.map((custAward) => {
              return (
                <tr>
                  <td>{custAward.name}</td>
                  <td>{custAward.description}</td>
                  <td style={{ textAlign: "center" }}>
                    <IconButton
                      onClick={() =>
                        this.edit(
                          custAward.awardId,
                          custAward.name,
                          custAward.description
                        )
                      }
                    >
                      <IconEdit />
                    </IconButton>
                    <IconButton
                      color="secondary"
                      onClick={() => this.delete(custAward.awardId)}
                    >
                      <IconDelete style={{ color: "red" }} />
                    </IconButton>
                  </td>
                </tr>
              );
            })}
            {this.state.customAwardsList.length === 0 && (
              <tr>
                <td colspan="4" style={{ textAlign: "center" }}>
                  No Custom Rewards Have Been Created...
                </td>
              </tr>
            )}
          </table>
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps }) {
  return {
    user,
    userId: user.userId,
    apps,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCustomRewards);



// WEBPACK FOOTER //
// ./src/layout/ManageCustomRewards.js